import { RootReducer } from '../rootReducer';

export const selectSolidMerchantData = (state: RootReducer) => state.payment.solidMerchantData;
export const selectIsMerchantLoading = (state: RootReducer) => state.payment.isMerchantDataLoading;
